/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Fragment, useState } from 'react';

import { useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import { cssMap, jsx } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/core/cross';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { OnlineDebuggerButton } from '../../../online-debugger/online-debugger-button';

import { messages } from './messages';

const styles = cssMap({
	container: {
		borderRadius: token('radius.small'),
		border: `${token('border.width')} solid ${token('color.border')}`,
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
	onlineDebuggerButtonContainer: {
		marginLeft: 'auto',
		width: 'fit-content',
	},
});

export const ErrorCard: ({ query }: { query: string }) => JSX.Element = ({
	query,
}: {
	query: string;
}) => {
	const { formatMessage } = useIntl();
	const [isOpen, setIsOpen] = useState(true);

	const showOnlineDebuggerButton = fg('kd_sain_online_debugger');

	return (
		<Fragment>
			{isOpen ? (
				<Stack space="space.100" xcss={styles.container}>
					<Inline spread="space-between" alignBlock="center">
						<Text weight="bold">{formatMessage(messages.errorMessage, { title: query })}</Text>
						<IconButton
							appearance="subtle"
							icon={CrossIcon}
							label={formatMessage(messages.close)}
							onClick={() => setIsOpen(false)}
						/>
					</Inline>
					{showOnlineDebuggerButton && (
						<Box xcss={styles.onlineDebuggerButtonContainer}>
							<OnlineDebuggerButton />
						</Box>
					)}
				</Stack>
			) : null}
		</Fragment>
	);
};
